import React from 'react'

import { ChipSwitch, ChipSwitchButton } from '../../components/ChipSwitch'
import { useFinancialsTableContext } from '../../components/financials-table'
import { ESTIMATE_TYPE_LABEL } from '../earnings-common/constants'
import { EarningsEstimateType, EarningsSettings } from '../earnings-common/types'

type Props = {
  hasDataByType: { [K in EarningsEstimateType]: boolean }
  label?: string
}

const options = Object.keys(ESTIMATE_TYPE_LABEL) as unknown as EarningsEstimateType[]

export function EstimateTypeChipSwitch({ hasDataByType, label }: Props) {
  const { settings, setSettings } = useFinancialsTableContext<EarningsSettings>()

  const toggleSetting = (key: keyof EarningsSettings, value: EarningsSettings[keyof EarningsSettings]) => {
    setSettings({
      ...settings,
      [key]: value,
    })
  }

  const estimateType = settings.estimateType

  return (
    <ChipSwitch size="small" label={label || ''}>
      {options.map((type) => (
        <ChipSwitchButton
          key={type}
          active={estimateType === type}
          disabled={!hasDataByType[type]}
          onClick={() => toggleSetting('estimateType', type)}
        >
          {ESTIMATE_TYPE_LABEL[type]}
        </ChipSwitchButton>
      ))}
    </ChipSwitch>
  )
}
